const ACCESS_TOKEN_KEY = "access_token";
const SESSION_EXPIRED_FLAG = "session_expired_message";

let cachedUserData = null;

export const getAccessToken = () => {
  try {
    return sessionStorage.getItem(ACCESS_TOKEN_KEY) || null;
  } catch {
    return null;
  }
};

export const setAccessToken = (token) => {
  if (!token) {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    return;
  }
  sessionStorage.setItem(ACCESS_TOKEN_KEY, String(token));
};

export const getCachedUserData = () => cachedUserData;

export const setCachedUserData = (data) => {
  cachedUserData = data && typeof data === "object" ? { ...data } : null;
};

/**
 * Persist only the token; keep full session payload in memory/context.
 */
export const establishAuthSession = (loginPayload) => {
  const token = loginPayload?.access_token;
  if (!token) {
    throw new Error("Login response missing access_token.");
  }
  setAccessToken(token);
  const { access_token: _omit, ...rest } = loginPayload;
  const user = { ...rest, access_token: token };
  setCachedUserData(user);
  return user;
};

export const clearAuthSession = () => {
  try {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    sessionStorage.removeItem("userData"); // legacy cleanup
    sessionStorage.removeItem("customerInfo");
    sessionStorage.removeItem("engageData");
    localStorage.removeItem("engageSiteData");
  } catch {
    /* ignore */
  }
  setCachedUserData(null);
};

export const markSessionExpired = () => {
  try {
    sessionStorage.setItem(SESSION_EXPIRED_FLAG, "1");
  } catch {
    /* ignore */
  }
};

export const consumeSessionExpiredMessage = () => {
  try {
    const flagged = sessionStorage.getItem(SESSION_EXPIRED_FLAG) === "1";
    if (flagged) sessionStorage.removeItem(SESSION_EXPIRED_FLAG);
    return flagged;
  } catch {
    return false;
  }
};

export const logoutForSessionExpired = () => {
  markSessionExpired();
  clearAuthSession();
  if (window.location.pathname !== "/") {
    window.location.replace("/");
  }
};
